/*
 *  Copyright (C) 2025 - SimpliCity Digital Inc - All Rights Reserved
 */

import React, { Fragment, useContext } from "react";
import LinkCreateContext from "cms/links/link-selector/context/create";

const LinkCreateHeader = () => {
    
    const {
        startClone,
        // setStartClone
    } = useContext(LinkCreateContext);

    let title = "Create New Link";
    if (startClone) {
        title = "Duplicate Link";
    }

    return (
        <Fragment>
            <div className="simplicity-link-selector-window-title">
                {title}
            </div>
        </Fragment>
    );
};

export default LinkCreateHeader;
